import { Controller } from '@hotwired/stimulus';

const noMax = Infinity;

export default class extends Controller {
	static values = {
		min: { type: Number, default: 0 },
		max: { type: Number, default: noMax }
	};

	static targets = ["input"];

	connect() {
	}

	decrement() {
		if (!this.inputTarget) {
			console.error("no input target");
			return;
		}

		const value = Number(this.inputTarget.value);
		if (value <= this.minValue) {
			return;
		}

		this.inputTarget.value = value - 1;

		var event = new Event('change');
		this.inputTarget.dispatchEvent(event);
	}

	increment() {
		if (!this.inputTarget) {
			console.error("no input target");
			return;
		}

		const value = this.inputTarget.value;
		if (value >= this.maxValue) {
			return;
		}

		this.inputTarget.value = 1 + Number(value);

		var event = new Event('change');
		this.inputTarget.dispatchEvent(event);
	}
}
